import React, { Component } from "react";
// import { HelpTip } from "@ali/ks-kp-bp-base-next";
// import { Table } from "@alifd/next";
//import "./index.scss";
import moment from "moment";
// import { getHashValue } from "@ali/ks-kp-bp-utils";
// import { getSolutionOrder } from "./services.js";
// import classnames from "classnames";

const linksA = [
  {
    title: "阿里巴巴集团",
    link: "https://www.alibabagroup.com/cn/global/home"
  },
  {
    title: "阿里巴巴国际站",
    link: "https://www.alibaba.com/"
  },
  {
    title: "1688",
    link: "https://www.1688.com/"
  },
  {
    title: "全球速卖通",
    link: "https://www.aliexpress.com/"
  },
  {
    title: "淘宝网",
    link: "https://www.taobao.com/"
  },
  {
    title: "天猫",
    link: "https://www.tmall.com/"
  },
  {
    title: "一淘",
    link: "https://www.etao.com/"
  },
  {
    title: "飞猪",
    link: "https://www.fliggy.com/"
  },
  {
    title: "阿里妈妈",
    link: "https://www.alimama.com/index.htm"
  },
  {
    title: "阿里云计算",
    link: "https://www.aliyun.com/"
  },
  {
    title: "AliOS",
    link: "http://www.alios.cn/"
  }
];
// 阿里通信|  UC  |支付宝|  钉钉  |旺旺|  阿里健康  |跨境供应链|  Lazada  |达摩院|  阿里安全天猫淘宝海外
const linksB = [
  {
    title: "阿里通信",
    link: "https://aliqin.tmall.com/"
  },
  {
    title: "UC",
    link: "http://www.uc.cn/"
  },
  {
    title: "支付宝",
    link: "https://www.alipay.com/"
  },
  {
    title: "钉钉",
    link: "https://www.dingtalk.com/"
  },
  {
    title: "旺旺",
    link: "https://wangwang.taobao.com/"
  },
  {
    title: "阿里健康",
    link: "https://www.alihealth.cn/"
  },
  {
    title: "跨境供应链",
    link: "https://onetouch.alibaba.com/"
  },
  {
    title: "Lazada",
    link: "https://taobao.lazada.sg/"
  },
  {
    title: "达摩院",
    link: "https://damo.alibaba.com/"
  },
  {
    title: "阿里安全",
    link: "https://s.alibaba.com/?scene=clinks"
  },
  {
    title: "天猫淘宝海外",
    link: "https://g-sellercenter.taobao.com/mail"
  }
];
// 关于阿里巴巴|  联系我们  |知识产权保护|  著作权与商标声明  |法律声明|  服务条款  |隐私政策|  网站导航
const linksC = [
  {
    title: "关于阿里巴巴",
    link: "https://www.alibabagroup.com/cn/global/home"
  },
  {
    title: "联系我们",
    link: "https://114.1688.com/kf/contact.html"
  },
  {
    title: "知识产权保护",
    link: "https://page.1688.com/trust/Intellectual.html"
  },
  {
    title: "著作权与商标声明",
    link: "https://rule.1688.com/policy/copyright.html"
  },
  {
    title: "法律声明",
    link: "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_b2b/suit_bu1_b2b201802011532_36855.html"
  },
  {
    title: "服务条款",
    link: "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_b2b/suit_bu1_b2b201703271338_74297.html"
  },
  {
    title: "隐私政策",
    link: "https://terms.alicdn.com/legal-agreement/terms/suit_bu1_b2b/suit_bu1_b2b201703271337_94551.html"
  },
  {
    title: "网站导航",
    link: "https://www.1688.com/alphabet_sitemap.html"
  }
];
//
const linksD = [
  {
    title: "医疗器械网络交易服务第三方平台备案证:(浙)网械平台备字[2018]第00001号",
    link: "https://img.alicdn.com/tfs/TB12RP9tMHqK1RjSZFkXXX.WFXa-1653-2339.jpg"
  },
  {
    title: "广播电视节目制作经营许可证:(浙)字第00523号"
  },
  {
    title: "增值电信业务经营许可证:浙B2-20120091-2",
    link: "http://beian.miit.gov.cn"
  }
];

const linksE = [
  {
    title: "浙江省网络食品销售第三方平台提供者备案:浙网食A33010005"
  },
  {
    title: "互联网药品信息服务资格证书:(浙)-经营性-2017-0008"
  },
  {
    icon: "https://gw.alicdn.com/tfs/TB15m.8rEY1gK0jSZFCXXcwqXXa-20-20.png",
    title: "浙公网安备 33010002000121号",
    link: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010002000121"
  }
];

const linksF = [
  {
    title: "出版物网络交易平台服务经营备案证:新出发浙备字第2017001号"
  },
  {
    title: "信息网络传播视听许可证:1109366号"
  }
];



/**
 * 组件描述 这是一个JS组件模板，将会在README.md 组件描述 中体现
 */
export default class Footer extends Component {
  
  render() {
    return (
      <div data-spm="szyxfooter" className="szyx-pc-footer-container">
        <div className="footer-main">
          <div className="footer-logo">
            <img src="https://img.alicdn.com/tfs/TB1FWIJcYj1gK0jSZFuXXcrHpXa-364-64.png" />
          </div>
          <div className="footer-link">
            <div className="inner-row">
              {linksA && linksA.length && linksA.map((item, idx) => {
                return (
                  <span>
                    <a href={item.link} target="_blank" key={idx}>{item.title}</a>
                    {(idx < linksA.length - 1) && (<span>|</span>)}
                  </span>
                )
              })}
            </div>
            <div className="inner-row">
              {linksB && linksB.length && linksB.map((item, idx) => {
                return (
                  <span>
                    <a href={item.link} target="_blank" key={idx}>{item.title}</a>
                    {(idx < linksB.length - 1) && (<span>|</span>)}
                  </span>
                )
              })}
            </div>
            <div className="inner-row">
              {linksC && linksC.length && linksC.map((item, idx) => {
                return (
                  <span>
                    <a href={item.link} target="_blank" key={idx}>{item.title}</a>
                    {(idx < linksC.length - 1) && (<span>|</span>)}
                  </span>
                )
              })}
            </div>
            <div className="outer-row">
              {linksD && linksD.length && linksD.map((item, idx) => {
                return (
                  <span>
                    {item.link && (<a href={item.link} target="_blank" key={idx}>{item.title}</a>) || (<span key={idx}>{item.title}</span>)}
                  </span>
                )
              })}
            </div>
            <div className="outer-row">
              {linksE && linksE.length && linksE.map((item, idx) => {
                return (
                  <span>
                    {item.icon && (<img src={item.icon} />)}
                    {item.link && (<a href={item.link} target="_blank" key={idx}>{item.title}</a>) || (<span key={idx}>{item.title}</span>)}
                  </span>
                )
              })}
            </div>
            <div className="outer-row">
              {linksF && linksF.length && linksF.map((item, idx) => {
                return (
                  <span>
                    {item.link && (<a href={item.link} target="_blank" key={idx}>{item.title}</a>) || (<span key={idx}>{item.title}</span>)}
                  </span>
                )
              })}
            </div>
            <div className="outer-row">
              <span>© 2010-{moment().format("YYYY")} 1688.com 版权所有</span>
              <span>互联网违法和不良信息举报中心:0571-81683755 blxx@list.alibaba-inc.com</span>
            </div>
            <div className="logo-list">
              <a className="c1" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010002000121" target="_blank" title="网络警察"></a>
              <a className="c2" href="http://idinfo.zjamr.zj.gov.cn//bscx.do?method=lzxx&id=3301083301080000022169" target="_blank" title="网络工商"></a>
              <a className="c3" href="https://ss.knet.cn/verifyseal.dll?sn=e12051133010020989301459" target="_blank" title="可信网站"></a>
              <a className="c4" href="http://www.12377.cn/" target="_blank" title="违法和不良信息举报中心"></a>
              <a className="c5" href="http://www.12377.cn/node_548446.htm" target="_blank" title="违法和不良信息举报中心APP下载"></a>
              <img src="https://img.alicdn.com/imgextra/i4/O1CN01j6Qjub1E4WlNpBJ0W_!!6000000000298-2-tps-210-99.png" alt="无障碍勋章" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
